import { LoggerService } from '../../common/common.module'
import { LocalDictionaryFactory } from './../../api/api.module'
import { ConsumerCreateEditController } from './consumers-create-edit.directive.controller'

import { ConsumerHelper } from '../consumers.helper'
import { DATA_TYPE_GROUP_SERVICE_NAME, DataTypeGroupService } from '../../../services/data-type'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session'

//#region Asset Imports

import './consumers-create-edit.scss'
import * as TEMPLATE from './consumers-create-edit.tpl.html'

//#endregion

// #region Setup

export class ConsumerCreateEditDirective implements ng.IDirective {

    restrict = 'E'

    controller = ['$scope', '$q', '$timeout', 'logger', USER_SESSION_SERVICE_NAME, DATA_TYPE_GROUP_SERVICE_NAME, 'localDictionary', (
        $scope: any,
        $q: ng.IQService,
        $timeout: ng.ITimeoutService,
        logger: LoggerService,
        userSessionService: UserSessionService,
        dataTypeGroupService: DataTypeGroupService,
        localDictionary: LocalDictionaryFactory
    ) => new ConsumerCreateEditController(
        $scope,
        $q,
        $timeout,
        logger,
        userSessionService,
        dataTypeGroupService,
        localDictionary,
        ConsumerHelper.REFERENCE_TYPE,
        ConsumerHelper.SIMAX_MODULE_NAME
    )]

    template = TEMPLATE
}

// #endregion
